var uiBreakdown = {
	table: {
		caption: "Détails",
		weight: "Pondération %",
		name: "Nom",
		noItems: "Aucun résultat trouvé"
	},
	chart: {
		counting: "Détails",
		topPositions: "Top positions",
		others: "Autres"
	}
};
var fr = {
	uiBreakdown: uiBreakdown
};

export { fr as default, uiBreakdown };
